export default __webpack_public_path__ + "static/media/robin-krubh.c940e1dd.png";